<template>
  <div>
    <md-card class="md-card-global-sales">
        <md-card-header class="md-card-header md-card-header-icon md-card-header-green">
            <h4 class="title" style="font-weight: 500">Performance Snapshot</h4>
        </md-card-header>
        <md-card-content>
            <div class="dynamicList-loading" v-show="isPromisePending">
                <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
            </div>
            <div class="md-layout">
                <div class="md-layout-item">              
                    <h3 class="title">
                        <animated-number v-if="loaded" :value="countTasksDueToday"></animated-number>
                    </h3>
                    <div>Tasks Due Today</div>
                </div>
                <div class="md-layout-item">
                    <h3 class="title">
                        <animated-number v-if="loaded" :value="countTasksDoneToday"></animated-number>
                    </h3>
                    <div>Tasks Done Today</div>
                </div>
                <div class="md-layout-item">
                    <h3 class="title">
                        <animated-number v-if="loaded" :value="countTasksRemaining"></animated-number>
                    </h3>
                    <div>Tasks Remaining</div>
                </div>
                <div class="md-layout-item">
                    <h3 class="title">
                        <animated-number v-if="loaded" :value="countTasksOverDue"></animated-number>
                    </h3>
                    <div>Overdue Tasks</div>
                </div>
            </div>
        </md-card-content>
    </md-card> 
  </div>
</template>

<script>
import moment from "moment";
import { AnimatedNumber } from "@/components";
import * as queries from '@/graphql/queries';
import {API, graphqlOperation } from 'aws-amplify';
export default {
  components: {
    AnimatedNumber
  },
  props: {
    taskList: {
        type: Array,
        required: true,
        default() {
            return []
        }
    },
  },
  data() {
    return {
        tasksDueToday: [],
        tasksDoneToday: [],
        tasksRemaining: [],
        tasksOverDue: [],
        countTasksDueToday: 0,
        countTasksDoneToday: 0,
        countTasksRemaining: 0,
        countTasksOverDue: 0,
        loaded: false,
        isPromisePending: true
    };
  },
  mounted(){
    if(this.taskList && this.taskList.length){
        this.calculateCount();
    }
  },
  methods: {
    calculateCount() {
        let filterStatus = ["Closed", "Completed", "Closed_By_Workflow"];
        if(this.taskList.length)
        {
            this.taskList.forEach(item => {
                if (
                    item.case !== null &&
                    item.isTemplate !== true &&
                    item.user !== null && 
                    item.user.cogUsername === this.$Session.user.username
                ) {                 

                    if(item.dateDue) {
                        const dateDue = moment(item.dateDue).endOf('day');
                        const yesterday = moment().subtract(1, 'days').endOf('day');
                        if (
                            dateDue.isSameOrBefore(yesterday)
                            && ['Open', 'WaitingOnCustomer', 'OnHold'].includes(item.status)
                        ) {
                            this.tasksOverDue.push(item);
                        }
                    }

                    if(item.dateDue && (moment(item.dateDue) <= moment()) && !filterStatus.includes(item.status)) {                                               
                         this.tasksRemaining.push(item);
                    }

                    /**
                     * ATLAS-828 - ATLAS-810 Impact: Dashboard Logic is working on 
                     * CLOSED status to find Tasks Done Today
                     */
                    if (item.status === "Completed" && item.dateCompleted && moment(item.dateCompleted).format('MMM DD, YYYY') == moment().format('MMM DD, YYYY')) {
                        this.tasksDoneToday.push(item);
                    }
                    /**
                     * ATLAS-864 - as per Stakeholder's requirement we are considering status to find Tasks Due Today
                     */
                    if(item.dateDue && (moment(item.dateDue) <= moment()) && !filterStatus.includes(item.status)) {                                                                       
                        if(item.case.isCompleteInOrder && !item.isAvailable) {                                               
                            return;
                        } else {
                            this.tasksDueToday.push(item);     
                        }                                        
                    }
                }
            });
        }

        this.countTasksDueToday = this.tasksDueToday.length;
        this.countTasksDoneToday = this.tasksDoneToday.length;
        this.countTasksRemaining = this.tasksRemaining.length;
        this.countTasksOverDue = this.tasksOverDue.length;
        this.loaded = true;
        this.isPromisePending = false;
    }
  },
  watch: {
    'taskList': {
      handler: function() {
        this.calculateCount();
      }
    }
  }
};
</script>
<style lang="css" scoped>

.dynamicList-loading {
  position: absolute;
  top: -5px;
  left: 50%;
  transform: translateX(-50%);
  bottom: auto;
  right: auto;
  display: block;
}

</style>